import { type SellerPromotionV2 } from '@redteclab/api/clients/bully'

import { type AlgoliaProxyRecord } from '../../../algolia'

export const productSearchAlgoliaAccessorGetBestOfferSellerPromotion = (
  algoliaRecord: AlgoliaProxyRecord,
): SellerPromotionV2 | undefined => {
  const { best_offer, hasBestOfferSellerPromotion } = algoliaRecord

  const sellerPromotion = best_offer?.seller_promotion

  if (!sellerPromotion || !hasBestOfferSellerPromotion) {
    return undefined
  }

  return sellerPromotion
}
